import type { SITE_RECENT_ACTIONS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-recent-actions-card/site-recent-actions-card.fr.ts";

export const SITE_RECENT_ACTIONS_CARD_ENGLISH_LOCALE = {
  title: "Recent actions",
  lastCall: "Last call",
  lastHardwareConfiguration: "Last hardware configuration",
  lastSoftwareConfiguration: "Last software update",
} satisfies typeof SITE_RECENT_ACTIONS_CARD_FRENCH_LOCALE;
